import API from "..";
export default class PiscesBacklog {
    /**
     * The Container dimension table for M3
     * @param TODO
     */
    constructor({
      methodName,
      testFacilityAbv,
      testFacilityName,
      conditionOfferingName,
      numberPending,
      numberInProgress,
      numberBacklog,

    }) {
      this.methodName = methodName;
      this.testFacilityAbv = testFacilityAbv;
      this.testFacilityName = testFacilityName;
      this.conditionOfferingName = conditionOfferingName;
      this.numberPending = numberPending;
      this.numberInProgress = numberInProgress;
      this.numberBacklog = numberBacklog;
      this.testFacilityFullName = `${testFacilityAbv} - ${testFacilityName}`;
    }


    static async get(testFacilities, methodNames) {
      const queryFacility = testFacilities.join('&testFacilities=');
      const queryMethod = methodNames.join('&methodNames=');
      const api = await API();
      const { data } = await api.get(`/piscesreporting/backlog?${queryFacility ? '&testFacilities=' + queryFacility : ''}${queryMethod ? '&methodNames=' + queryMethod : ''}`);

      return data.result.map((d) => new PiscesBacklog(d));
    }

}